<script>
import ShowOptions from '@components/show/show-options'

export default {
    components: {
        ShowOptions,
    },
    props: {
        show: {
            type: Object,
            default: () => {},
        },
    },
    computed: {},
}
</script>

<template>
    <div class="tile">
        <div class="tile-wrapper">
            <div class="tile-content">
                <BaseLink :to="{ name: 'show', params: { id: show.id } }">
                    <BaseResourceImage
                        :resource="show"
                        class="image"
                        :should-lazyload="false"
                    />
                </BaseLink>
            </div>
            <div
                class="options"
                @click.prevent="() => {}"
            >
                <BaseDropdown :padded="false">
                    <BaseButton
                        slot="trigger"
                        :modifiers="{ autoWidth: true, transparent: true, dots: true }"
                        aria-label="Options"
                        button-type="tag"
                        size="small"
                    />
                    <div slot="dropdown">
                        <ShowOptions :show="show" />
                    </div>
                </BaseDropdown>
            </div>
        </div>
        <BaseLink
            v-if="show && show.title"
            class="title show-link"
            :to="{ name: 'show', params: { id: show.id } }"
        >
            <div class="title">{{ show.title }}</div>
        </BaseLink>
        <div
            v-if="show.artist"
            class="artist"
        >
            <BaseLink :to="{ path: `/artist/${show.artist.url}/${show.artist.id}` }">
                {{ show.artist.title }}
            </BaseLink>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.tile-wrapper {
    position: relative;

    &:hover {
        .tile-content::after {
            opacity: 0.5;
        }

        .options {
            opacity: 1;
        }
    }
}

.tile-content {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 150px;
    overflow: hidden;

    &::after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        content: '';
        background: $c-purple-red-gradient;
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
    }
}

.options {
    position: absolute;
    top: $s-m;
    right: $s-m;
    z-index: $layer-dropdown-z-index;
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
}

.image {
    @include center;

    width: 100%;
}

.title {
    @extend %contentTitleM;

    margin-top: $size-grid-padding;
    line-height: 24px;
    text-align: center;
}

.artist {
    @extend %contentSubtitleM;

    text-align: center;
}

@include tablet {
    .tile-content {
        height: 200px;
    }
}

@include desktop {
    .options {
        opacity: 0;
    }
}
</style>
